var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshCw1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_28679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.75L4.75 12.75L12.75 4.75ZM4.75 4.75L12.75 12.75L4.75 4.75Z",
    fill: "#4D4D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.75L4.75 12.75M4.75 4.75L12.75 12.75",
    stroke: "#4D4D4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_28679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshCw1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh-cw 1.5e3ecca3bc65a0b2945c25f9369b7e3a.svg";